import { KybDocumentStatus } from '@shinetools/kyb-library';

import { VerificationStepStatus } from 'features/Onboarding/legacy/components/VerificationStep/types';

const STEP_TO_VERIFICATION_STATUS_MAP: Record<
  KybDocumentStatus,
  VerificationStepStatus
> = {
  MISSING: 'waiting',
  PENDING: 'pending',
  PREVALIDATED: 'pending',
  REFUSED: 'error',
  VALIDATED: 'complete',
};

const getKybDocumentStatus = (document: KybDocumentStatus) =>
  STEP_TO_VERIFICATION_STATUS_MAP[document];

export default getKybDocumentStatus;
